var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 18C1.08333 18 0.729167 17.8511 0.4375 17.5532C0.145833 17.2553 0 16.8936 0 16.4681V6.51064C0 6.27234 0.0541666 6.04255 0.1625 5.82128C0.270833 5.6 0.416667 5.42128 0.6 5.28511L7.1 0.306383C7.23333 0.204255 7.375 0.12766 7.525 0.0765958C7.675 0.025532 7.83333 0 8 0C8.16667 0 8.325 0.025532 8.475 0.0765958C8.625 0.12766 8.76667 0.204255 8.9 0.306383L15.4 5.28511C15.5833 5.42128 15.7292 5.6 15.8375 5.82128C15.9458 6.04255 16 6.27234 16 6.51064V16.4681C16 16.8936 15.8542 17.2553 15.5625 17.5532C15.2708 17.8511 14.9167 18 14.5 18H10V10.8511H6V18H1.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.9b2c65fef154bbd53d97b8559765f51c.svg";
export { ForwardRef as ReactComponent };